import { CardSkeleton, DashCard } from "../DashboardCards";
import { COLORS } from "../../configs/config";
import { Box, Typography } from "@mui/material";
import { Bar, BarChart, Cell, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { BarTip } from "../DashboardTooltip";
import { ChartLegend } from "./ChartLegend";

export const RetiradasChart = ({ data, period, loading }) => {
    if (loading) return <CardSkeleton height={160} />;

    const chartData = [
        { name: "Retiradas",   value: data?.totalRetiradas   ?? 0, color: COLORS.chartBar1 },
        { name: "Requisições", value: data?.totalRequisicoes ?? 0, color: COLORS.chartBar2 },
    ];

    return (
        <DashCard title="Retiradas × Requisições" tag={`últimos ${period} dias`}>
            <ChartLegend items={chartData.map((d) => ({ color: d.color, label: d.name }))} />
            <Box sx={{ position: "relative", height: 160 }}>
                <ResponsiveContainer width="100%" height="100%">
                    <BarChart data={chartData} margin={{ top: 4, right: 4, left: -20, bottom: 0 }}>
                        <XAxis
                            dataKey="name"
                            tick={{ fill: COLORS.tDim, fontSize: 10 }}
                            axisLine={{ stroke: COLORS.border }}
                            tickLine={false}
                        />
                        <YAxis
                            tick={{ fill: COLORS.tDim, fontSize: 9 }}
                            axisLine={false}
                            tickLine={false}
                        />
                        <Tooltip content={<BarTip />} cursor={{ fill: COLORS.kpiBg }} />
                        <Bar dataKey="value" name="Total" radius={[4, 4, 0, 0]} maxBarSize={48}>
                            {chartData.map((d, i) => <Cell key={i} fill={d.color} />)}
                        </Bar>
                    </BarChart>
                </ResponsiveContainer>
            </Box>
            <Box display="flex" justifyContent="center" mt={1}>
                <Typography variant="caption" sx={{ color: COLORS.tDim }}>
                    Total:{" "}
                    <Box component="span" sx={{ color: COLORS.g2, fontWeight: 700 }}>
                        {(data?.total ?? 0).toLocaleString("pt-BR")}
                    </Box>
                </Typography>
            </Box>
        </DashCard>
    );
};